import React from "react";

// import CYBRSCRTYBNR from "../assets/Banner/WebBanner/CyberSecurity.png";
import CyberPlan from "../components/CyberProtect/CyberPlan";
import Header from "../layout/Header";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import WebDarkMonitor from "../components/CyberProtect/WebDarkMonitor";
import CustomerReviews from "../components/AutomobileAssistance/CustomerReviews";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";
import FAQ from "../components/FAQ";

const CyberSecurity = () => {
  const FAQdata = [
    {
      question: "What is Cyber Security and why do I need it?",
      answer:
        "Cyber Security defends your data, money, and identity from threats like hacking, phishing, and fraud. If you use the internet or digital devices, cyber security is a must for your protection.",
    },
    {
      question: "What does your Cyber Security plan cover?",
      answer:
        "We protect against personal data breaches, online financial fraud, identity theft, phishing, and online scams. Our plan also includes dark web monitoring and cyberbullying protection.",
    },
    {
      question: "How does Dark Web Monitoring help me?",
      answer:
        "We scan hidden parts of the web for your leaked info. If your email or details are found, you receive an instant alert so you can act fast to secure your accounts.",
    },
    {
      question: "What support do I get if something goes wrong?",
      answer:
        "You'll get expert guidance to recover hacked accounts, report fraud, and minimize losses. We help you respond quickly and strengthen your defenses.",
    },
    {
      question: "Can this plan protect my whole family?",
      answer:
        "Yes, our coverage includes children and other family members—helping keep everyone safe from threats such as cyberbullying and identity misuse.",
    },
  ];
  return (
    <>
      <HeroSection
        bannerImage={banner1}
        heading="Cyber Security"
        description="Wherever the road takes you, our cyber security is ready 24/7. From breakdowns and flat tires to emergency fuel delivery and towing, we ensure help is always within reach. Drive with confidence, knowing expert support is just a call away."
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      />

      <CyberPlan />

      <WebDarkMonitor />
      <FAQ
        FAQdata={FAQdata}
        sectionTitle="Frequently Asked Questions"
        sectionDescription="Find answers to the most common questions below. If you need more help, contact our support."
      />

      <CustomerReviews />
    </>
  );
};

export default CyberSecurity;
